<div class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>Bring lost pets home faster</h1>
        <h6>Whether it’s an unexpected adventure or a sudden escape, register and protect  your pet today to get them home faster</h6>
        <button (click)="navigateToLoginRegister()" type="button" class="btn orange-button px-sm-2 px-lg-5 px-md-5 mt-lg-3 mt-md-3 mt-sm-1">Get started now</button>
      </div>
    </div>
  </div>
</div>
